/**
 * @file How It Works.
 */

/**
 * How It Works functions.
 *
 * Runs js specific to the How It Works template.
 */
const vHowItWorks = () => {
	import('../../components/anchor-menu/anchor-menu').then((m) => { m.default(); });
};

if (document.readyState !== 'loading') {
	vHowItWorks();
} else {
	document.addEventListener('DOMContentLoaded', vHowItWorks);
}
